export const payload = state => state.payload
export const options = state => state.options
export const paymentMethod = state => state.paymentMethod
export const api_key = state => state.api_key
export const cardDetails = state => state.cardDetails
export const card_cc = state => state.card_cc
export const card_cvv = state => state.card_cvv
export const card_exp = state => state.card_exp
export const channels = state => state.channels
export const hasOtp = state => state.hasOtp
export const isLoading = state => state.isLoading
export const isFailed = state => state.isFailed
export const transRef = state => state.transRef
export const parentTransRef = state => state.parentTransRef
export const provider = state => state.provider
export const paymentMethodIndex = state => state.paymentMethodIndex
export const popupReferrer = state => state.popupReferrer
export const client_info = state => state.client_info
export const app_info = state => state.app_info
export const optionsTransRef = state => state.optionsTransRef
export const paymentMethodProvider = state => state.paymentMethodProvider
export const showDefaultView = state => state.showDefaultView
export const service_call_payload = state => state.service_call_payload
export const mPGSCardUsed = state => state.mPGSCardUsed
export const customer_processing_fee = state => state.customer_processing_fee
